export const GRAMMAR_SUGGESTION_OPEN_EVENT = "suggestion-open";
export const GRAMMAR_SUGGESTION_CLOSE_EVENT = "suggestion-close";
export const GRAMMAR_SUGGESTION_CANCEL_CLOSE_EVENT = "suggestion-cancel-close";
